import { FC, useContext, useReducer } from "react";
import UserContext from "../UserContext";
import { DefaultPlayer } from "../utils/Player";
import { useParams } from "react-router-dom";
import { setNewUser } from "../utils/FetchPlayerData";
import OverlayDisplay from "../components/OverlayDisplay";
import { Button } from "@mui/material";
import EditControls from "../components/EditControls";


import { QueryKeys } from "./Overlay";
import Footer from "../components/Footer";

export enum EditActionType {
    ToggleDisplayName = 'ToggleDisplayName',
    ToggleConnectCode = 'ToggleConnectCode',
    ToggleRankIcon = 'ToggleRankIcon',
    ToggleRankName = 'ToggleRankName',
    ToggleRankNumber = 'ToggleRankNumber',
    ToggleWinLoss = 'ToggleWinLoss',
    SetBackgroundColor = 'SetBackgroundColor'
}

export interface EditState {
    showDisplayName: boolean;
    showConnectCode: boolean;
    showRankIcon: boolean;
    showRankName: boolean;
    showRankNumber: boolean;
    showWinLoss: boolean;
    backgroundColor: { r: 35, g: 37, b: 44, a: 1; };
}

function editReducer(state: EditState, action: { type: EditActionType, payload?: any; }) {
    switch (action.type)
    {
        case EditActionType.ToggleDisplayName:
            return { ...state, showDisplayName: !state.showDisplayName };
        case EditActionType.ToggleConnectCode:
            return { ...state, showConnectCode: !state.showConnectCode };
        case EditActionType.ToggleRankIcon:
            return { ...state, showRankIcon: !state.showRankIcon };
        case EditActionType.ToggleRankName:
            return { ...state, showRankName: !state.showRankName };
        case EditActionType.ToggleRankNumber:
            return { ...state, showRankNumber: !state.showRankNumber };
        case EditActionType.SetBackgroundColor:
            return { ...state, backgroundColor: action.payload };
        case EditActionType.ToggleWinLoss:
            return { ...state, showWinLoss: !state.showWinLoss };
    }
}

const Edit: FC = () => {
    const { user, setUser } = useContext(UserContext);

    const [ state, dispatch ] = useReducer(editReducer, {
        showDisplayName: true,
        showConnectCode: true,
        showRankIcon: true,
        showRankName: true,
        showRankNumber: true,
        backgroundColor: { r: 35, g: 37, b: 44, a: 1 },
        showWinLoss: true
    });

    const params = useParams();

    if (user === DefaultPlayer)
    {
        setNewUser(params.id, setUser);
    }

    const { r, g, b, a } = state.backgroundColor;

    return (
        <div className='App-header'>
            <p>Editing { user.displayName } overlay</p>

            <div className='Edit'>
                <EditControls
                    dispatch={ dispatch }
                    showDisplayName={ state.showDisplayName }
                    showConnectCode={ state.showConnectCode }
                    showRankIcon={ state.showRankIcon }
                    showRankName={ state.showRankName }
                    showRankNumber={ state.showRankNumber }
                    backgroundColor={ state.backgroundColor }
                    showWinLoss={ state.showWinLoss }
                />
                <div className='editOverlayPreview'>
                    <p className='editOverlayPreviewText'>preview</p>
                    <div className='overlayPreview'>
                        <OverlayDisplay
                            user={ user }
                            showDisplayName={ state.showDisplayName }
                            showConnectCode={ state.showConnectCode }
                            showRankIcon={ state.showRankIcon }
                            showRankName={ state.showRankName }
                            showRankNumber={ state.showRankNumber }
                            showWinLoss={ state.showWinLoss }
                            backgroundColor={ `rgba(${r},${g},${b},${a})` }
                        />
                    </div>
                </div>
            </div>
            <Button variant='contained' onClick={ () => {
                let query = `${QueryKeys.ShowDisplayName}=${state.showDisplayName}`;
                query += `&${QueryKeys.ShowConnectCode}=${state.showConnectCode}`;
                query += `&${QueryKeys.ShowRankIcon}=${state.showRankIcon}`;
                query += `&${QueryKeys.ShowRankName}=${state.showRankName}`;
                query += `&${QueryKeys.ShowRankNumber}=${state.showRankNumber}`;
                query += `&${QueryKeys.ShowWinsLosses}=${state.showWinLoss}`;
                query += `&${QueryKeys.BackgroundColor}=rgba(${r},${g},${b},${a})`;

                navigator.clipboard.writeText(`${document.location.host}/overlay/${params.id}?${query}`);

                alert('Overlay link coppied to clipboard!');
            } }>Get Overlay Link</Button>
            <Footer />
        </div>
    );
};

export default Edit;